// extracted by mini-css-extract-plugin
export default {"card":"accordion_card__gMrd8"};